import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { DropdownList } from 'react-widgets';
import {
  Page,
  Card,
  Button,
  Dimmer,
  Alert,
  Table,
  Form,
  Icon,
  Text
} from 'tabler-react';
import * as moment from 'moment';
import { NavLink } from 'react-router-dom';
import { SiteWrapper } from '../common';
import { findWorkItemsByAssignee, findUsers, getWorkItemByReferenceNum, patchWorkItem } from '../actions';

import Auth from '../auth/auth';

const auth = new Auth({});

class RequisitionReportPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCheckedLoader: false,
      isLockedLoader: false,
      loading: false,
      workItemAssignees: [],
      from: moment().format('DD/MM/YYYY'),
      to: moment().format('DD/MM/YYYY'),
      userName: '',
      alert: {
        display: false,
        type: '',
        icon: '',
        message: '',
      },
    };

    this.fetchWorkItems = this.fetchWorkItems.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.renderWorkItem = this.renderWorkItem.bind(this);
    this.renderReportActions = this.renderReportActions.bind(this);
    this.handleLockOrCheckAssignees = this.handleLockOrCheckAssignees.bind(this);

    this.getUserName = this.getUserName.bind(this);
  }

  componentDidMount() {
    this.fetchWorkItems();
    this.props.findUsers(1, 1000000);
  }

  fetchWorkItems() {
    this.setState({ loading: true });

    const page = 1;
    const pageSize = 100000;
    const { from, to, userName } = this.state;
    const status = 'Approved';
    const type = 'Assigned_To_Me';

    const formatFrom = `${moment(from, 'DD/MM/YYYY').format(
      'YYYY-MM-DD'
    )} 00:00:00`;
    const formatTo = `${moment(to, 'DD/MM/YYYY').format(
      'YYYY-MM-DD'
    )} 23:59:59`;

    console.log('userName', userName, this.isAdmin());

    this.props.findWorkItemsByAssignee(
      {
        page,
        pageSize,
        from: formatFrom,
        to: formatTo,
        type,
        status,
        order: 'referenceNum',
        userName: this.isAdmin() ? userName : auth.name,
      },
      (response) => {
        console.log('fetchWorkItems', 'findWorkItemsByAssignee', response);
        for(var i = 0; i < response.data.items.length; ++i) {
          response.data.items[i].isLoader = false;
        }
    
        this.setState({
          loading: false,
          workItemAssignees: response.data.items,
        });
      },
      (error) => {
        console.log('fetchWorkItems', 'findWorkItemsByAssignee', error);
        this.setState({ loading: false, workItemAssignees: [] });
      }
    );
  }

  isAdmin() {
    return auth.hasAccess('request', 'admin');
  }

  getUserName() {
    if (this.isAdmin()) {
      return this.state.userName;
    } else {
      return auth.name;
    }
  }





  onChangeDateTo(event) {
    console.log('onChangeDateTo', event.target.value);
    // let to = event.target.value
  }

  handleChange(event) {
    const { target } = event;
    const { value, name } = target;
    this.setState({ [name]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.fetchWorkItems();
  }

  renderAlert() {
    return (
      <div>
        {this.state.alert.display && (
          <Alert
            type={this.state.alert.type}
            icon={this.state.alert.icon}
            isDismissible
          >
            {this.state.alert.message}
          </Alert>
        )}
      </div>
    );
  }

  

  handleLockOrCheckAssignees(workItemAssignee, type) {
    const { workItemAssignees } = this.state;

    const { workItem, userName } = workItemAssignee;
    const { referenceNum } = workItem;

    (workItemAssignees[workItemAssignees.indexOf(workItemAssignee)]).isLoader = true;
    this.setState({ getWorkItemLoader: true, workItemAssignees: workItemAssignees });

    this.props.getWorkItemByReferenceNum(referenceNum, (response) => {

      let { data } = response;
      let { assignees } = data;
      let isFlag = false;

      for (var index = 0; index < assignees.length; ++index) {
        if (assignees[index].userName === userName) {

          if ((assignees[index])[type] == null)
            (assignees[index])[type] = true;
          else
            (assignees[index])[type] = !(assignees[index])[type];

          isFlag = (assignees[index])[type];
        }
      }

      
      console.log("before patch", assignees, workItem.referenceNum);
      this.props.patchWorkItem({
        referenceNum: workItem.referenceNum, patchData: [
          {
            value: assignees,
            path: `/assignees`,
            op: 'replace',
          }
        ]
      }, (response) => {
        console.log("after patch", response);
        (workItemAssignees[workItemAssignees.indexOf(workItemAssignee)])[type] = isFlag;
        (workItemAssignees[workItemAssignees.indexOf(workItemAssignee)]).isLoader = false;
        this.setState({ getWorkItemLoader: false, workItemAssignees: workItemAssignees });

      }, (error) => {
        console.error('handleLockOrCheck', type, 'patchWorkItem', error);
        (workItemAssignees[workItemAssignees.indexOf(workItemAssignee)]).isLoader = false;
        this.setState({ getWorkItemLoader: false, workItemAssignees: workItemAssignees });
      });

    });
  }

  renderReportActions(workItemAssignee, type) {

    const { isCheckedLoader, isLockedLoader } = this.state;
    const { workItem, isChecked, isLocked } = workItemAssignee;
    const isAdmin = this.isAdmin();


    if (type === "isLocked") {
      return (
        <React.Fragment>
          <Button className="mr-2" loading={workItemAssignee.isLoader} color={isLocked ? 'success' : 'secondary'} icon="lock" type="button" onClick={() => this.handleLockOrCheckAssignees(workItemAssignee, type)} disabled={!isAdmin} />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <Button className="mr-2" loading={workItemAssignee.isLoader} color={isChecked ? 'success' : 'secondary'} icon="check" type="button" onClick={() => this.handleLockOrCheckAssignees(workItemAssignee, type)} disabled={!isAdmin} />
      </React.Fragment>
    );
  }


  renderWorkItem(workItemAssignee) {
    const { workItem } = workItemAssignee;
    const { references } = workItem;
    const userName = this.getUserName();

    const filteredReferences = [];
    //console.log('workItem', workItem);
    //console.log("xxxxx", workItemAssignee);

    for (const r of references) {
      const createdByAttribute = r.attributes.find(
        (a) => a.key && a.key.replace(/\s/g, '').toLowerCase() === 'createdby'
      );
      // console.log(
      //   'reference',
      //   r.referenceNum,
      //   'createdByAttribute',
      //   createdByAttribute
      // );

      // for those that doesn't have created by attribute, to support legacy, we allow it to show
      if (!createdByAttribute) {
        filteredReferences.push(r);
        continue;
      }

      let closedByAttribute = r.attributes.find(
        (a) => a.key && a.key.replace(/\s/g, '').toLowerCase() === 'closedby'
      );
      if (!closedByAttribute) closedByAttribute = { value: '' };

      let modifiedByAttribute = r.attributes.find(
        (a) => a.key && a.key.replace(/\s/g, '').toLowerCase() === 'modifiedby'
      );
      if (!modifiedByAttribute) modifiedByAttribute = { value: '' };

      const canDisplay = (attribute) => {
        const name = userName.toLowerCase();
        const { value, type } = attribute;

        if (type && type.toLowerCase() === 'array') {
          const { arrayValue } = JSON.parse(`{ "arrayValue": ${value} }`);
          if (Array.isArray(arrayValue)) {
            return arrayValue.includes((v) => v && v.toLowerCase() === name);
          }
        }
        return value.toLowerCase() === name;
      };

      const canDisplayCreatedBy = canDisplay(createdByAttribute);
      const canDisplayModifiedBy = canDisplay(modifiedByAttribute);
      const canDisplayClosedBy = canDisplay(closedByAttribute);

      // console.log(
      //   'createdByAttribute.value',
      //   createdByAttribute.value,
      //   'userName',
      //   userName,
      //   'canDisplay',
      //   canDisplayCreatedBy
      // );
      // console.log(
      //   'modifiedByAttribute.value',
      //   modifiedByAttribute.value,
      //   'userName',
      //   userName,
      //   'canDisplay',
      //   canDisplayModifiedBy
      // );
      // console.log(
      //   'closedByAttribute.value',
      //   closedByAttribute.value,
      //   'userName',
      //   userName,
      //   'canDisplay',
      //   canDisplayClosedBy
      // );

      if (canDisplayCreatedBy || canDisplayModifiedBy || canDisplayClosedBy) {
        filteredReferences.push(r);
      }

      // console.log('filteredReference', r.referenceNum, filteredReferences);
    }

    return (
      <Table.Body key={`${workItem.id}_${workItemAssignee.userName}`}>
        <Table.Row>
          <Table.Col className="fontSmall">{workItem.code}</Table.Col>
          <Table.Col>
            <NavLink to={`/requisition/item/${workItem.referenceNum}`}>
              {workItem.referenceNum}
            </NavLink>
          </Table.Col>
          <Table.Col className="reportRemark">{workItem.name}<Text className="reportRemarkText">{workItem.remarks}</Text></Table.Col>
          <Table.Col>
            <NavLink to={`/requisition/${workItem.workRequest.referenceNum}`} className="fontSmall">
              {workItem.workRequest.referenceNum}
            </NavLink>
          </Table.Col>
          <Table.Col className="fontSmall">{workItemAssignee.progress}</Table.Col>
          <Table.Col className="fontSmall">{workItem.submittedBy}</Table.Col>
          {this.isAdmin() && <Table.Col className="fontSmall">{workItemAssignee.userName}</Table.Col>}
          <Table.Col className="fontSmall">
            {moment(workItemAssignee.createdOn).format('DD/MM/YYYY')}
          </Table.Col>
          <Table.Col>
            {filteredReferences.map((r, i) => (
              <React.Fragment key={`${r.referenceNum}_${i}`}>
                <span className="mr-1 fontSmall">
                  <a href={r.url} target="_blank">
                    {r.referenceNum}
                  </a>
                </span>
                {(i + 1) % 4 === 0 && <br />}
              </React.Fragment>
            ))}
          </Table.Col>
          <Table.Col>
            {this.renderReportActions(workItemAssignee, "isChecked")}
            {/* <Icon prefix="fa" name={workItemAssignee.isChecked ? 'check' : ''} /> */}
          </Table.Col>
          <Table.Col>
            {this.renderReportActions(workItemAssignee, "isLocked")}
            {/* <Icon prefix="fa" name={workItemAssignee.isLocked ? 'check' : ''} /> */}
          </Table.Col>

        </Table.Row>
        <Table.Row className="only-print table-row">
          <Table.Col colSpan="1">
            <b>Remarks</b>
          </Table.Col>
          <Table.Col colSpan={this.isAdmin() ? 9 : 6}>
            <Form.Group className="p-0 m-0">
              <Form.Textarea rows={1} />
            </Form.Group>
          </Table.Col>
        </Table.Row>
      </Table.Body>
    );
  }

  render() {
    const { loading, workItemAssignees, from, to, userName } = this.state;
    const { users } = this.props;
    const userList = [{ label: 'All', value: '' }];
    userList.push(
      ...(users.items || []).map(({ userName }) => ({
        label: userName,
        value: userName,
      }))
    );

    const test = {
      width: "30%"
    };

    return (
      <SiteWrapper>
        <Page.Content>
          {this.renderAlert()}
          <Card>
            <Card.Header className="no-print">
              <Card.Title>
                <div className="d-flex flex-row justify-content-between">
                  <span>Report</span>
                </div>
              </Card.Title>
              <Card.Options className="no-print">
                <Form onSubmit={this.handleSubmit}>
                  <Form.Group className="mb-0">
                    <Form.InputGroup>
                      {this.isAdmin() && (
                        <DropdownList
                          className="mr-3"
                          defaultValue={{
                            label: userName || 'All',
                            value: userName,
                          }}
                          dataKey="value"
                          textField="label"
                          data={userList}
                          filter={(item, value) => {
                            return (
                              item.label
                                .toLowerCase()
                                .indexOf(value.toLowerCase()) > -1
                            );
                          }}
                          onChange={(item) => {
                              this.setState({ userName: item.value });
                          }}
                        />
                      )}
                      <Form.MaskedInput
                        name="from"
                        placeholder="e.g. 23/01/2018"
                        mask={[
                          /\d/,
                          /\d/,
                          '/',
                          /\d/,
                          /\d/,
                          '/',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        onChange={this.handleChange}
                        value={from}
                      />
                      <Form.InputGroupAppend className="pt-2 pl-2 pr-2">
                        -
                      </Form.InputGroupAppend>
                      <Form.MaskedInput
                        name="to"
                        placeholder="e.g. 23/01/2018"
                        mask={[
                          /\d/,
                          /\d/,
                          '/',
                          /\d/,
                          /\d/,
                          '/',
                          /\d/,
                          /\d/,
                          /\d/,
                          /\d/,
                        ]}
                        onChange={this.handleChange}
                        value={to}
                      />
                      <Form.InputGroupAppend>
                        <Button color="success">Show</Button>
                      </Form.InputGroupAppend>
                      <Form.InputGroupAppend>
                        <Button
                          type="button"
                          icon="printer"
                          color="primary"
                          onClick={() => {
                            window.print();
                          }}
                        >
                          Print
                        </Button>
                      </Form.InputGroupAppend>
                    </Form.InputGroup>
                  </Form.Group>
                </Form>
              </Card.Options>
            </Card.Header>
            <Dimmer active={loading} loader>
              <Table
                responsive
                className="card-table table-vcenter text-nowrap"
              >
                <Table.Header>
                  <Table.Row className="only-print">
                    <Table.ColHeader
                      className="pt-5 pb-5"
                      colSpan={this.isAdmin() ? 10 : 9}
                    >
                      <div className="d-flex flex-row w-100 text-bold justify-content-between">
                        <span>
                          Report&nbsp;for&nbsp;<strong>{auth.name}</strong>
                        </span>
                        <span>
                          {from} to {to}
                        </span>
                        <span>
                          Printed: {moment().format('DD/MM/YYYY, hh:mm a')}
                        </span>
                        {/* <span className="print-page-number">Page &nbsp;</span> */}
                      </div>
                    </Table.ColHeader>
                  </Table.Row>
                  <Table.Row>
                    <Table.ColHeader className="reportItemCode">Item Code</Table.ColHeader>
                    <Table.ColHeader>ID</Table.ColHeader>
                    <Table.ColHeader>Item Name</Table.ColHeader>
                    <Table.ColHeader>PRF</Table.ColHeader>
                    <Table.ColHeader>Progress</Table.ColHeader>
                    <Table.ColHeader>Submitted By</Table.ColHeader>
                    {this.isAdmin() && (
                      <Table.ColHeader>Assigned To</Table.ColHeader>
                    )}
                    <Table.ColHeader>Assigned Date</Table.ColHeader>
                    <Table.ColHeader>Reference</Table.ColHeader>
                    <Table.ColHeader>Check</Table.ColHeader>
                    <Table.ColHeader>Lock</Table.ColHeader>

                  </Table.Row>
                </Table.Header>
                {workItemAssignees
                  .sort((a, b) => {
                    const aDate = moment(a.createdOn);
                    const bDate = moment(b.createdOn);
                    if (aDate.isAfter(bDate)) {
                      return -1;
                    }
                    if (aDate.isBefore(bDate)) {
                      return 1;
                    }
                    return 0;
                  })
                  .map((i) => this.renderWorkItem(i))}
              </Table>
            </Dimmer>
          </Card>
        </Page.Content>
      </SiteWrapper>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    findWorkItemsByAssignee,
    findUsers,
    getWorkItemByReferenceNum,
    patchWorkItem


  }, dispatch);
}

function mapStateToProps({ users }) {
  return { users };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequisitionReportPage);



// WEBPACK FOOTER //
// ./src/requisition/report.react.js